<template>
	<div :class="enteredClass">
		<img v-if="user !== undefined && user.attachment" :src="user.attachment.url"/>
		<img src="../assets/img/doctor_avatar.png" v-else-if="user !== undefined && user.sex !== undefined">
		<img src="../assets/img/clinic_avatar.png" v-else-if="user !== undefined  && user.founder !== undefined">
		<img src="../assets/img/clinic_avatar.png" v-else-if="user !== undefined  && user.time !== undefined">
	</div>
</template>

<script>
	import {getColor, getLetter} from '@/libs/nameToAvatar'

	export default {
		name: "UserAvatar",
		props: ['data', 'setClass'],
		computed: {
			user() {
				if (this.data) {
					if (!this.data.last_name) {
						this.data.last_name = this.data.clinic_name || this.data.name
					}

					return this.data
				}
			},
			enteredClass() {
				if (this.setClass)
					return this.setClass.split(' ')
			}
		},
		methods: {
			getColor: getColor,
			getLetter: getLetter
		}
	}
</script>



// WEBPACK FOOTER //
// UserAvatar.vue?07689802